
export default function install ( mod ) {

    /**
     * Este filtro nos fornece o tempo em dias horas minutos 
     * e segundos em relação a data que foi passada por paramentro.
     * 
     * @param {object} data
     */
    mod.filter('tempoDecorrido', ['$filter', function ($filter) {
        return function (data) {

            // Define o locale
            moment.locale('pt-br');

            // Cria uma instância da data
            var dataInicial = moment(data);

            // Verifica se é uma data válida
            if (!dataInicial.isValid()) return;

            // Retorna o tempo decorrido
            return moment.duration(moment().diff(dataInicial))
                        .humanize();

        };
    }])

    /**
     * Verifica se um item existe na coleção
     * 
     * @param {object} data
     */
    mod.filter('tem', [function () {
        return function (colecao, item, retornoTrue, retornoFalse) {

            var tem = !!_.filter(colecao, function (i) {
                return i == item;
            }).length;

            if (retornoTrue && retornoFalse) {
                return tem ? retornoTrue : retornoFalse;
            }

            return tem;

        };
    }])

    /**
     * Limita uma sequencia de caracteres
     * 
     * @param {string} texto
     */
    mod.filter('limitar', [function() {
        return function ( texto, tamanho, borda ) {

            tamanho = tamanho || 100;
            borda = borda || '...';

            if (tamanho && texto.length > tamanho) {
                return texto.slice(0, tamanho) + borda;
            }

            return texto;
        };
    }])

    /**
     * Limpa um determinado texto de tags html
     * [trocar o nome do filtro por um nome mais sugestivo]
     * 
     * @param {string} texto
     */
    mod.filter('htmlLimpo', ['$filter', function ($filter) {
            return function (html, tamanho) {
                var texto = html ? String(html).replace(/<[^>]+>/gm, '').replace(/&nbsp;/gm, ' ') : ' ';

                return $filter('limitar')( texto, tamanho );
            };
        }
    ])

    /**
     * Exibe a dimensão do arquivo
     * 
     * @param {object} dimensao
     */
    mod.filter('dimensaoArquivo', [function () {
        return function (bytes, decimals) {
            if (!bytes) {
                return '';
            } else if (bytes == 0) {
                return '0 Byte'
            };
            var k = 1000;
            var dm = decimals + 0 || 3;
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            var i = Math.floor(Math.log(bytes) / Math.log(k));
            return (parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]) || '';
        }
    }])

    /**
     * Busca itens de forma recurso em uma coleção
     * de itens ou um objeto segmentado.
     * 
     * @param input (object|date)
     */
    mod.filter('buscar', ['$filter', function buscarFtr($filter) {
        return function (colecao, procudado) {
            function fn(colecao, procudado) {
                var find = _.find(colecao, procudado);
                if (find) return [find];
                return _.flatten(_.map(colecao, function (v) {
                    return typeof v == "object" ? fn(v, procudado) : [];
                }), true);
            }
            return fn(colecao, procudado);
        };
    }])

    mod.filter('toArray', function () {
        return function (object) {
            return _.values(object)
        }
    } )

}


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/plugins/filters.plugin.js
// module id = 323
// module chunks = 1